import React from 'react';

import {
  List,
} from '@mui/material';

import type { ChildJson } from '@/types/domain/child/entities/childEntity';
import type { FacilityJson } from '@/types/domain/childApply/entities/facilityEntity';

import CustomListItem from '@/components/CustomListItem';
import { Birthday } from '@/domain/child/service/entity/valueObjects/birthday';
import { Gender } from '@/domain/child/service/entity/valueObjects/gender';
import { toStringDateDisplay } from '@/utils/date';

const ChildInfo: React.FC<{
  /** データ */
  data: ChildJson,
  /** childFacilityList */
  childFacilityList: FacilityJson[],
}> = ({ data, childFacilityList }) => (
  <List>
    <CustomListItem
      name="氏名"
      content={`${data.familyName.toString()} ${data.name.toString()}`}
      secondary={`${data.familyNameKana.toString()} ${data.nameKana.toString()}`}
    />
    <CustomListItem name={Gender.label} content={data.gender.toString()} />
    <CustomListItem
      name={Birthday.label}
      content={toStringDateDisplay(new Date(data.birthday), false)}
    />
    {childFacilityList.map((v) => (
      <CustomListItem
        key={v.data.facilityId}
        name="施設名"
        content={v.data.facilityName}
        secondary={v.data.tel}
      />
    ))}
  </List>
);

export default ChildInfo;
